import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [CommonModule, ReactiveFormsModule],
})
export class LoginComponent {
  loginForm: FormGroup;
  errorMessage: string = '';

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  onSubmit(): void {
    // Sync browser-autofilled values Angular may have missed (no input event fired)
    const usernameEl = document.getElementById('username') as HTMLInputElement;
    const passwordEl = document.getElementById('password') as HTMLInputElement;
    if (usernameEl?.value) this.loginForm.get('username')?.setValue(usernameEl.value, { emitEvent: false });
    if (passwordEl?.value) this.loginForm.get('password')?.setValue(passwordEl.value, { emitEvent: false });

    if (this.loginForm.valid) {
      this.http.post<{ access_token: string, refresh_token: string }>(`${environment.apiUrl}/login`, this.loginForm.value)
        .subscribe({
          next: (response) => {
            localStorage.setItem('token', response.access_token);
            localStorage.setItem('refresh-token', response.refresh_token);
            this.router.navigate(['/fishing']); // Redirect after login
          },
          error: (error) => {
            this.errorMessage = 'Invalid username or password';
          }
        });
    }
  }
  logOut(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh-token');
    this.router.navigate(['/login']); // Redirect after logout
  }
}